import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { loadDOMComponent } from '../../../../helpers';
import { AppContextProvider } from '../../../../Services/AppContext';
import { store } from '../../../../store/store';
import AclContextProvider from '../../../Acl/Components/AclContextProvider';
import WorkplaceSelectPHP from './WorkplaceSelectPHP';

loadDOMComponent({
	selector: 'react-workplace-select',
	callback: ({ container, context, props }: any) => {
		const name = container.getAttribute('name');
		const placeholder = container.getAttribute('placeholder');
		const reactParams = JSON.parse(container.getAttribute('react-params'));
		const value = container.getAttribute('value');
		const netteRules = container.getAttribute('data-nette-rules');
		let required = container.getAttribute('required');
		required = required !== false && required !== null;

		ReactDOM.render(
			<Provider store={store}>
				<AppContextProvider {...context}>
					<AclContextProvider>
						<WorkplaceSelectPHP
							name={name}
							value={value}
							excludedIds={reactParams?.excludedIds}
							data-nette-rules={netteRules}
							placeholder={placeholder}
						/>
					</AclContextProvider>
				</AppContextProvider>
			</Provider>,
			container,
		);
	},
});
